import * as React from 'react'
import { Widget, mk_widget, any } from 'widgets-for-react'
import { styleguideChapter, styleguideSection, styleguidePart, styleguideExample } from '../helpers.mod'
import { header } from '../fake_data/header'
import { footer } from '../fake_data/footer'
import { pageheader, homepagePageheader } from '../fake_data/pageheader'
import { cookiebarClosed, cookiebarOpen } from '../fake_data/cookiebar'
import {
  FakeTextBlock,
  FakeCMSState,
  FakeDownloadBlock,
  FakeLinkGridTextBlock,
  FakeLinkGridTextImageBlock,
  FakeLinkGridImageBlock,
  FakeMediaBlockImages as FakeMediaBlock,
  FakeCtaBlockText,
  FakeCtaBlockImage,
  FakeQuoteBlockText,
  FakeLinkBlock,
  FakeTextImageLeftBlock,
  FakeTextImageRightBlock,
  FakeExpandBlock,
  FakeStoriesBlock,
  FakePressReleaseBlock
} from '../fake_data/buildingblocks'
import { fakeContactForm, fakeBimForm } from '../fake_data/forms'
import { formClasses } from '../../components/public_site/blocks/style.mod'
import { headerDesktop } from '../fake_data/header_desktop'
import { topNavBar } from '../fake_data/topNavBar'
import { languageSwitch } from '../fake_data/languageSwitch'
import { filtersOverlay } from '../fake_data/filtersOverlay'
import { applyBlock } from '../fake_data/fakeApplyBlock'
import { recruitmentBlock } from '../fake_data/fakeRecruitmentBlock'
import { QuotesBlock } from '../../components/public_site/blocks/custom_blocks/widgets/quotes'
import { FeaturedContentBlock } from '../../components/public_site/blocks/custom_blocks/widgets/featuredContent'
import { UpdatesBlock } from '../../components/public_site/blocks/custom_blocks/widgets/latestUpdates'


export const styleguideComponents: Widget<never> = mk_widget({
         run: (_) =>
           styleguideChapter({ type: 'components', slug: 'components', title: 'Design Components', intro: '' })(
             any()([
               styleguideSection({ type: 'components', slug: 'components-apply', title: 'Apply Block', intro: '' })(
                styleguidePart({ title: '', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({
                      run: () => applyBlock() })
                  )
                )
              ),
              styleguideSection({ type: 'components', slug: 'components-cta', title: 'CTA Block', intro: '' })(
                any()([
                  styleguidePart({ title: 'Text only', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: (_) => FakeCtaBlockText(FakeCMSState).run(_) })
                    )
                  ),
                  styleguidePart({ title: 'Text & image', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: (_) => FakeCtaBlockImage(FakeCMSState).run(_) })
                    )
                  )
                ])
              ),
              styleguideSection({ type: 'components', slug: 'components-blocks-color', title: 'Block with grey background', intro: '' })(
                any()([
                  styleguidePart({ title: 'Image left - Text right', intro: '', extraClasses: 'block--color' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      any()([
                        mk_widget({ run: () => FakeTextImageLeftBlock(FakeCMSState).run(_) }),
                        mk_widget({ run: (_) => FakeCtaBlockImage(FakeCMSState).run(_) }),
                        mk_widget({ run: () => FakeTextImageRightBlock(FakeCMSState).run(_) }),
                        mk_widget({ run: () => FakeMediaBlock(FakeCMSState).run(_) }),
                        mk_widget({ run: (_) => FakeCtaBlockText(FakeCMSState).run(_) }),
                        mk_widget({ run: (_) => FakeQuoteBlockText(FakeCMSState).run(_) }),
                        mk_widget({ run: (_) => footer() })
                      ])
                    )
                  )
                ])
              ),
              styleguideSection({ type: 'components', slug: 'components-download', title: 'Download Block', intro: '' })(
                any()([
                  styleguidePart({ title: 'Default', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: (_) => FakeDownloadBlock(FakeCMSState).run(_) })
                    )
                  )
                ])
              ),
              styleguideSection({ type: 'components', slug: 'components-expand', title: 'Expand Block', intro: '' })(
                any()([
                  styleguidePart({ title: 'Default', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: (_) => FakeExpandBlock(FakeCMSState).run(_) })
                    )
                  )
                ])
              ),
              styleguideSection({ type: 'components', slug: 'components-featured-content', title: 'Featured content', intro: '' })(
                styleguidePart({ title: 'Image right, blue background image', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({ run: () => 
                      <FeaturedContentBlock
                      isStyleguide={true}
                        alignImage="right"
                        backgroundImage="blue"
                        label="News"
                        title="KKR to Acquire Majority Stake in Refresco"
                        intro="KKR has signed a definitive agreement to acquire a majority stake in Refresco, with Refresco’s existing investors maintaining a significant minority position."
                        imageStyleguide={{
                          src: '/styleguide/images/1920x1080.png',
                          srcSet: '/styleguide/images/1920x1080.png 1920w',
                          alt: 'alt text',
                        }}
                        button={{
                          text: 'Read more',
                          url: '/',
                        }}
                      /> 
                    })
                  )
                )
              ),
              styleguideSection({ type: 'components', slug: 'components-featured-content', title: 'Featured content', intro: '' })(
                styleguidePart({ title: 'Image left, orange background image', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({ run: () => 
                      <FeaturedContentBlock
                        isStyleguide={true}
                        alignImage="left"
                        backgroundImage="orange"
                        label="Vision & Values"
                        title="Creating beverage solutions that matter"
                        intro="When we look to the future with our clients and suppliers, we aim for positive changes with a lasting effect. We focus on three areas to drive sustainable action: people, products & processes."
                        imageStyleguide={{
                          src: '/styleguide/images/1920x1080.png',
                          srcSet: '/styleguide/images/1920x1080.png 1920w',
                          alt: 'alt text',
                        }}
                        button={{
                          text: 'Read more',
                          url: '/',
                        }}
                      /> 
                    })
                  )
                )
              ),
              styleguideSection({ type: 'components', slug: 'components-footer', title: 'Footer', intro: '' })(
                any()([
                  styleguidePart({ title: 'Default', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: (_) => footer() })
                    )
                  )
                ])
              ),
              styleguideSection({ type: 'components', slug: 'components-gallery', title: 'Image gallery block', intro: '' })(
                styleguidePart({ title: '', intro: '', extraClasses: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({
                      run: () => (
                        <section className="block block--background block--gallery grid--block">
                          <div className="block__inner container container--s grid--block">
                           <header className="block__header">
                               <h2 className="block__title title--m">Block title</h2>
                               <p className="block__intro">Donec ullamcorper nulla non metus auctor fringilla. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
                           </header>
                           <div className={'block__content'}>
                             <ul className="gallery" data-gallery-show-more="true">
                               <li className="gallery__item" data-gallery-more="+4">
                                 <figure className="gallery__visual">
                                   <img src="http://placehold.it/800x800" width="800" height="800" className="gallery__image" alt="" />
                                 </figure>
                               </li>
                               <li className="gallery__item" data-gallery-more="+3">
                                 <figure className="gallery__visual">
                                   <img src="http://placehold.it/800x800" width="800" height="800" className="gallery__image" alt="Donec ullamcorper nulla non metus auctor fringilla" />
                                 </figure>
                               </li>
                               <li className="gallery__item" data-gallery-more="+2">
                                 <figure className="gallery__visual">
                                   <img src="http://placehold.it/800x800" width="800" height="800" className="gallery__image" alt="Nullam id dolor id nibh ultricies vehicula ut id elit" />
                                 </figure>
                               </li>
                               <li className="gallery__item" data-gallery-more="+1">
                                 <figure className="gallery__visual">
                                   <img src="http://placehold.it/800x800" width="800" height="800" className="gallery__image" alt="Nullam id dolor id nibh ultricies vehicula ut id elit " />
                                 </figure>
                               </li>
                             </ul>
                           </div>
                         </div>
                        </section>
                      )
                    })
                  )
                )
              ),
              styleguideSection({ type: 'components', slug: 'components-updates', title: 'Latest updates', intro: '' })(
                styleguidePart({ title: '', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({ run: () => 
                      <UpdatesBlock
                        title="Our latest updates"
                        isStyleguide={true}
                        items={[
                          {
                            imageStyleguide: {
                              src: '/styleguide/images/1920x1080.png',
                              srcSet: '/styleguide/images/1920x1080.png 1920w',
                              alt: 'Deniz',
                            },
                            category: 'Story',
                            title: 'Stepping up our sustainability commitments in the UK',
                            link: '/',
                          },
                          {
                            category: 'Press release',
                            title: 'Refresco Group publishes Annual Report 2021',
                            link: '/',
                          },
                          {
                            imageStyleguide: {
                              src: '/styleguide/images/1920x1080.png',
                              srcSet: '/styleguide/images/1920x1080.png 1920',
                              alt: 'Deniz',
                            },
                            category: 'Story',
                            title: 'Hosting our first virtual Supplier Day',
                            link: '/',
                          },
                          {
                            category: 'Press release',
                            title: 'KKR to acquire majority stake in Refresco',
                            link: '/',
                          },
                        ]} /> 
                    })
                  )
                )
              ),
              styleguideSection({ type: 'components', slug: 'components-linkgrid', title: 'Link Grid Block', intro: '' })(
                any()([
                  styleguidePart({ title: 'Text only', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: () => FakeLinkGridTextBlock(FakeCMSState).run(_) })
                    )
                  ),
                  styleguidePart({ title: 'Text & image', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: () => FakeLinkGridTextImageBlock(FakeCMSState).run(_) })
                    )
                  ),
                  styleguidePart({ title: 'Image only', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: () => FakeLinkGridImageBlock(FakeCMSState).run(_) })
                    )
                  )
                ])
              ),
              styleguideSection({ type: 'components', slug: 'components-links', title: 'Link List Block', intro: '' })(
                any()([
                  styleguidePart({ title: 'Default', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: () => FakeLinkBlock(FakeCMSState).run(_) })
                    )
                  )
                ])
              ),
              styleguideSection({ type: 'components', slug: 'components-media', title: 'Media Block', intro: '' })(
                any()([
                  styleguidePart({ title: 'Default', intro: '' })(
                    styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                      mk_widget({ run: () => FakeMediaBlock(FakeCMSState).run(_) })
                    )
                  )
                ])
              ),
              styleguideSection({ type: 'components', slug: 'components-releases', title: 'Press release Block', intro: '' })(
                styleguidePart({ title: '', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({
                      run: () => (
                        <section className="block block--releases">
                          <div className="block__inner container container--m grid--block">
                            <header className="block__header">
                              <h2 className="block__title title--l">Press releases</h2>
                            </header>
                            <div className="block__content">
                              <ul className="block__list grid">{FakePressReleaseBlock(FakeCMSState)}</ul>
                            </div>
                          </div>
                        </section>
                      )
                    })
                  )
                )
              ),
              styleguideSection({ type: 'components', slug: 'components-quote', title: 'Quote Block', intro: '' })(
                styleguidePart({ title: 'Text only', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({ run: (_) => FakeQuoteBlockText(FakeCMSState).run(_) })
                  )
                )
              ),
              styleguideSection({ type: 'components', slug: 'components-quotes', title: 'Quotes', intro: '' })(
               styleguidePart({ title: 'Multiple quotes', intro: '' })(
                 styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                   mk_widget({ run: () => 
                     <QuotesBlock
                       title="Meet our people"
                       isStyleguide={true}
                       quotes={[
                         {
                           imageStyleguide: {
                             src: '/styleguide/images/1920x1080.png',
                             srcSet: '/styleguide/images/1920x1080.png 1920w',
                             alt: 'Deniz',
                           },
                           person: 'Deniz',
                           person_function: 'Plant Manager',
                           quote: 'I make it my business to foster a personal connection with my staff.',
                           btn: {
                             url: '/',
                             label: 'Read his story',
                           },
                         },
                         {
                           imageStyleguide: {
                             src: '/styleguide/images/1920x1080.png',
                             srcSet: '/styleguide/images/1920x1080.png 1920w',
                             alt: 'Walt',
                           },
                           person: 'Walt Whitman',
                           person_function: 'Plant Manager',
                           quote: 'Keep your face always toward the sunshine - and shadows will fall behind you.',
                         },
                         {
                           imageStyleguide: {
                             src: '/styleguide/images/1920x1080.png',
                             srcSet: '/styleguide/images/1920x1080.png 1920w',
                             alt: 'Muhammad',
                           },
                           person: 'Muhammad Ali',
                           person_function: 'Plant Manager',
                           quote: 'The man who views the world at 50 the same as he did at 20 has wasted 30 years of his life.',
                         },
                       ]} /> 
                   })
                 )
               )
             ),
             styleguideSection({ type: 'components', slug: 'components-recruit', title: 'Precruitment Process Block', intro: '' })(
              styleguidePart({ title: '', intro: '' })(
                styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                  mk_widget({
                    run: () => recruitmentBlock() })
                )
              )
            ),
            styleguideSection({ type: 'components', slug: 'components-spacer', title: 'Custom spacer bBlock', intro: '' })(
              styleguidePart({ title: '', intro: '' })(
                styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                  mk_widget({
                    run: () => (
                      <section className="block block--custom-spacer">
                        <div className="block__inner" />
                      </section>
                    ) })
                )
              )
            ),
            styleguideSection({ type: 'components', slug: 'components-stories', title: 'Stories Block', intro: '' })(
              styleguidePart({ title: '', intro: '' })(
                styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                  mk_widget({
                    run: () => (
                      <section className="block block--stories">
                        <div className="block__inner">
                          <header className="block__header container container--s grid--gutter">
                            <h2 className="block__title title--l">Dolor Justo Sollicitudin Porta</h2>
                          </header>
                          <div className="block__content">
                            <div className="block__container container container--m grid--gutter">
                              <ul className="block__list grid">{FakeStoriesBlock(FakeCMSState)}</ul>
                            </div>
                            <footer className="block__footer container container--m grid--gutter">
                              <a className="button button--primary" href="/">
                                Luctus vitae
                              </a>
                            </footer>
                          </div>
                        </div>
                      </section>
                    )
                  })
                )
              )
            ),
            styleguideSection({ type: 'components', slug: 'components-text', title: 'Text Block', intro: '' })(
              any()([
                styleguidePart({ title: 'Default', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({ run: (_) => FakeTextBlock(FakeCMSState).run(_) })
                  )
                )
              ])
            ),
            styleguideSection({ type: 'components', slug: 'components-text-image', title: 'Text Image Block', intro: '' })(
              any()([
                styleguidePart({ title: 'Image left - Text right', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({ run: () => FakeTextImageLeftBlock(FakeCMSState).run(_) })
                  )
                ),
                styleguidePart({ title: 'Image right - Text left', intro: '' })(
                  styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                    mk_widget({ run: () => FakeTextImageRightBlock(FakeCMSState).run(_) })
                  )
                )
              ])
            ),               
            styleguideSection({ type: 'components', slug: 'components-timeline', title: 'Timeline Block', intro: '' })(
              styleguidePart({ title: '', intro: '' })(
                styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                  mk_widget({
                    run: () => (
                      <section className="block block--timeline">
                        <div className="block__inner container container--m grid--block">
                          <header className="block__header container container--m">
                            <h2 className="block__title title--l">Dolor Justo Sollicitudin Porta</h2>
                            <div className="block__intro">
                              Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Cum
                              sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                              Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nullam quis risus
                              eget urna mollis ornare vel eu leo. Donec sed odio dui.
                            </div>
                          </header>
                          <div className="block__content">
                            <ul className="block__list">
                            <li className="block__item item">
                                <div className="item__inner">
                                  <div className="item__content">
                                    <div className="item__message">
                                    <img
                                      src="/styleguide/images/640x360.png"
                                      data-src="/styleguide/images/640x360.png"
                                      data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
                                      data-sizes="auto"
                                      className="item__icon"
                                      alt=""
                                    />
                                      <h3 className="item__title title--m">year X</h3>
                                      <div className="item__intro">
                                        Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod
                                        semper. Cum sociis natoque penatibus et magnis dis parturient montes,
                                        nascetur ridiculus mus. Integer posuere erat a ante venenatis dapibus posuere
                                        velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo. Donec
                                        sed odio dui.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li className="block__item block__item--has-visual">
                                  <div className="item__content">
                                  <div className="item__visual">
                                    <img
                                      src="/styleguide/images/640x360.png"
                                      data-src="/styleguide/images/640x360.png"
                                      data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
                                      data-sizes="auto"
                                      className="item__image"
                                      alt=""
                                    />
                                  </div>
                                  <div className="item__message">
                                    <h3 className="item__title title--m">year X</h3>
                                    <div className="item__intro">
                                      Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod
                                      semper. Cum sociis natoque penatibus et magnis dis parturient montes,
                                      nascetur ridiculus mus. Integer posuere erat a ante venenatis dapibus posuere
                                      velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo. Donec
                                      sed odio dui.
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li className="block__item item">
                                <div className="item__inner">
                                  <div className="item__content">
                                    <div className="item__message">
                                    <img
                                      src="/styleguide/images/640x360.png"
                                      data-src="/styleguide/images/640x360.png"
                                      data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
                                      data-sizes="auto"
                                      className="item__icon"
                                      alt=""
                                    />
                                      <h3 className="item__title title--m">year X</h3>
                                      <div className="item__intro">
                                        Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod
                                        semper. Cum sociis natoque penatibus et magnis dis parturient montes,
                                        nascetur ridiculus mus. Integer posuere erat a ante venenatis dapibus posuere
                                        velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo. Donec
                                        sed odio dui.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li className="block__item item">
                                <div className="item__inner">
                                  <div className="item__content">
                                    <div className="item__message">
                                    <img
                                      src="/styleguide/images/640x360.png"
                                      data-src="/styleguide/images/640x360.png"
                                      data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
                                      data-sizes="auto"
                                      className="item__icon"
                                      alt=""
                                    />
                                      <h3 className="item__title title--m">year X</h3>
                                      <div className="item__intro">
                                        Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod
                                        semper. Cum sociis natoque penatibus et magnis dis parturient montes,
                                        nascetur ridiculus mus. Integer posuere erat a ante venenatis dapibus posuere
                                        velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo. Donec
                                        sed odio dui.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li className="block__item item">
                                <div className="item__inner">
                                  <div className="item__content">
                                    <div className="item__message">
                                    <img
                                      src="/styleguide/images/640x360.png"
                                      data-src="/styleguide/images/640x360.png"
                                      data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
                                      data-sizes="auto"
                                      className="item__icon"
                                      alt=""
                                    />
                                      <h3 className="item__title title--m">year X</h3>
                                      <div className="item__intro">
                                        Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod
                                        semper. Cum sociis natoque penatibus et magnis dis parturient montes,
                                        nascetur ridiculus mus. Integer posuere erat a ante venenatis dapibus posuere
                                        velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo. Donec
                                        sed odio dui.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </section>
                    )
                  })
                ),
              )
            ),
            // styleguideSection({ type: 'components', slug: 'components-forms', title: 'Forms', intro: '' })(
            //   any()([
            //     styleguidePart({ title: 'Contact Form', intro: '' })(
            //       styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            //         mk_widget({
            //           run: (_) => (
            //             <>
            //               {fakeContactForm({ style: formClasses }, false)}
            //               {fakeContactForm({ style: formClasses }, true)}
            //             </>
            //           )
            //         })
            //       )
            //     ),
            //     styleguidePart({ title: 'Request BIM Objects and Technical Drawings form', intro: '' })(
            //       styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            //         mk_widget({
            //           run: () => (
            //             <>
            //               {fakeBimForm({ style: formClasses }, false)}
            //               {fakeBimForm({ style: formClasses }, true)}
            //             </>
            //           )
            //         })
            //       )
            //     )
            //   ])
            //  ),
            ])
           ).run(_)
       })
